import React, { useEffect, useState } from 'react';
import { find, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { buildHotelBySlugSelector } from 'store/selectors/hotels.selector';
import { loadHotelBySlug } from 'store/dispatchers/hotels.dispatchers';
import { withRouteParams } from 'hoc/withRouteParams';
import { compose } from 'redux';
import getFinalAttribute from 'utils/alternative-attribute';
import PropTypes from 'prop-types';
import { hotelUrl } from 'utils/routing-helper';
import { withLayout } from 'components/Components/Layouts/ThemeContext/with-layout';
import Jumbo from 'components/Components/Sections/Jumbo';

const ClusterPage = ({
    themeContext,
    params,
    hotel,
    loadHotelBySlug: loadHotelBySlugFunc,
    clusters,
}) =>
{
    const [currentSlug, setCurrentSlug] = useState(null);

    useEffect(() =>
    {
        themeContext.configHeader({
            defaultBg: 'header-white',
        });
        loadDataIfNeeded(params.hotelSlug);
    }, []);

    const loadDataIfNeeded = (slug) =>
    {
        const slugChanged = currentSlug !== slug;

        if (slugChanged)
        {
            setCurrentSlug(slug);
        }

        if (slugChanged && isEmpty(hotel))
        {
            loadHotelBySlugFunc(slug);
        }
    };

    const currentCluster = find(clusters, { url: params.roomSlug });

    return (
        <div>
            <Jumbo
                image={currentCluster.clusterImg}
                title={currentCluster.title}
                subtitle={(
                    <a
                        href={hotelUrl(params.regionSlug, params.parentDestinationSlug, params.destinationSlug, params.hotelSlug)}
                        className="tw-text-white tw-font-normal font-sp tw-uppercase tw-mt-3"
                    >
                        {getFinalAttribute(hotel, 'name')}
                    </a>
                )}
                vanish
            />
            <section className="tw-py-10 lg:tw-py-20 tw-px-4">
                <div className="xl:tw-container tw-text-center">
                    <section
                        className="font-arapey tw-text-3xl lg:tw-text-3xl tw-font-normal tw-text-gray-700 leading-12"
                        dangerouslySetInnerHTML={{
                            __html: currentCluster.content,
                        }}
                    />
                </div>
            </section>
        </div>
    );
};

ClusterPage.propTypes = {
    hotel: PropTypes.object.isRequired,
    loadHotelBySlug: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    clusters: PropTypes.array.isRequired,
    themeContext: PropTypes.object.isRequired,
};

const mapStateToProps = () =>
{
    const hotelSelector = buildHotelBySlugSelector();
    return (state, props) => ({
        hotel: hotelSelector(state, props.params.hotelSlug),
        clusters: JSON.parse(getFinalAttribute(hotelSelector(state, props.params.hotelSlug), 'cluster')) || [],
    });
};

const mapDispatchToProps = () => dispatch => ({
    loadHotelBySlug(slug)
    {
        return dispatch(loadHotelBySlug(slug));
    },
});

export default compose(
    withLayout,
    withRouteParams,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ClusterPage);
